import React from 'react'
import { dateToText } from './utils'

const DateFormat = ({ date }) => {
  return <> {dateToText(date)} </>
}

export default DateFormat
